<script lang="ts">
  import bg_shapes_img from "@images/home/home-shapes-bg.png"
</script>

<div class="relative px-3 lg:px-0">
  <div
    class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 lg:py-10 relative bg-lwp-dark-grey rounded-lg"
  >
    <div class="absolute inset-0">
      <img
        src={bg_shapes_img}
        class="w-full h-full object-cover"
        alt="Bottom CTA Background"
      />
    </div>
    <div
      class="max-w-2xl mx-auto relative px-4 py-6 lg:px-8 bg-lwp-dark-grey/[0.9]"
    >
      <h1
        class="text-center text-2xl font-extrabold tracking-tight sm:text-3xl lg:text-5xl"
      >
        <span class="block text-white">Join Industry Leaders Today!</span>
      </h1>
      <div
        class="mt-10 max-w-sm mx-auto sm:max-w-none sm:flex sm:justify-center"
      >
        <div class="mx-auto">
          <a
            href="/signup"
            class="flex items-center justify-center px-4 py-4 border border-transparent text-base font-bold shadow text-white bg-green-600 hover:bg-green-500 sm:px-8 rounded-xl"
          >
            Start Your Free Plan
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="bg-lwp-accent h-24 -mt-24"></div>
